import { enUS, es, fr, ptBR } from 'date-fns/locale';
import { getLanguage } from './languageManager';

/** Locale data for date-fns controls and relative dates. */
export const getDateLocale = () => ({ 'pt-BR': ptBR, en: enUS, es, fr }[getLanguage()] ?? ptBR);
